export default __webpack_public_path__ + "static/media/dinners_club_logo.9457c595.svg";